export class Log {
  public info(message: string, metadata?: { [key: string]: any }) {
    console.log(message, metadata);
  }

  public warn(message: string, metadata?: { [key: string]: any }) {
    console.warn(message, metadata);
  }

  public error(message: string, metadata?: { [key: string]: any }) {
    console.error(message, metadata);
  }
}

export const log = new Log();

export default log;
